import React from 'react';
import PropTypes from 'prop-types';

import CopyOption from "core/gd-modals/copy/components/copy-project/copy-options/copy-option"

export default function FormTemplateCopyOptions(props) {
    const copyOptions = [];

    if (props.template.templateContent) {
        const { events, subProjects, tasks } = props.template.templateContent;
        if (events)         copyOptions.push({id: "events",         title: "Events"});
        if (subProjects)    copyOptions.push({id: "subProjects",    title: "Subprojects"});
        if (tasks)          copyOptions.push({id: "tasks",          title: "Tasks"});
    }

    if (copyOptions.length<1) return false;

    const selectedOptions = props.form.getValue('copyOptions');

    return (
        <div className="row">
            <div className="label">Template content</div>
            <div className="element">
                {copyOptions.map(o=><CopyOption key={o.id} id={o.id} title={o.title} selected={selectedOptions.includes(o.id)} onSelect={props.onCopyOptionSelect}/>)}
            </div>
            <div className="cf"/>
        </div>
    )
}

FormTemplateCopyOptions.propTypes = {
    form: PropTypes.object,
    template: PropTypes.object,

    onCopyOptionSelect: PropTypes.func
}